import { render, staticRenderFns } from "./DescriptionIndicador.vue?vue&type=template&id=06e3641e&scoped=true"
import script from "./DescriptionIndicador.vue?vue&type=script&lang=js"
export * from "./DescriptionIndicador.vue?vue&type=script&lang=js"
import style0 from "./DescriptionIndicador.vue?vue&type=style&index=0&id=06e3641e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e3641e",
  null
  
)

export default component.exports